import { CloseOutlined } from "@ant-design/icons";
import { Button, Modal, Progress, Spin, Typography } from "antd";
import { useEffect, useRef, useState } from "react";
import { uploadMultipartFile } from "../../../api/authentication/storageApi";
import { useInfoUser } from "../../../store/UserStore";
import { openNotificationError } from "../../../utils/Utils";
import "./style.scss";

const PreviewUploadModal = ({
  isModalOpen,
  handleCancel,
  setDataForm,
  uploadFile,
  setPreviewFile,
  setIsOpenUploadModal,
}) => {
  const { languageMap } = useInfoUser();
  const abortController = useRef(null);
  const fileUploading = useRef(null);
  const [progressState, setProgressState] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);

  const sendFile = async () => {
    const controller = new AbortController();
    abortController.current = controller;

    try {
      fileUploading.current = uploadFile;

      const resource = await uploadMultipartFile({
        file: uploadFile,
        bucket: "public",
        signal: controller.signal,
        onProgress: ({ percent }) => updateProgress(uploadFile, percent),
      });

      if (!controller.signal.aborted) {
        setDataForm({
          originalName: uploadFile?.name,
          mainPath: resource?.location,
          videoImgPreviewPath: resource?.videoImgPreviewPath,
          width: resource?.videoImgPreviewWidth,
          height: resource?.videoImgPreviewHeight,
          duration: resource?.videoDuration,
          volume: resource?.fileSize ?? uploadFile?.size,
          contentType: resource?.contentType || uploadFile?.type,
          uid: uploadFile?.uid,
        });

        setPreviewFile(uploadFile);
      }
    } catch (error) {
      if (!controller.signal.aborted) {
        console.error("Error uploading version file:", error);
        openNotificationError(
          languageMap?.["error.uploadFailed"] || "Upload failed, try again later"
        );
      }
    } finally {
      fileUploading.current = null;
    }
  };

  const handleDeleteFile = () => {
    abortController.current?.abort();
  };

  const updateProgress = (file, percent) => {
    setProgressState((prev) => ({
      ...prev,
      [file.uid]: percent,
    }));
  };

  const getFileSize = (file) => {
    if (!file?.size) return "0 KB";

    const sizeInMB = file.size / (1024 * 1024);
    const sizeInKB = file.size / 1024;

    return sizeInMB >= 1
      ? `${sizeInMB.toFixed(1)} MB`
      : `${sizeInKB.toFixed(1)} KB`;
  };

  const handleCloseModal = () => {
    handleStopAllUploads();
    handleCancel();
    setProgressState({});
  };

  const handleStopAllUploads = () => {
    abortController.current?.abort();
  };

  useEffect(() => {
    if (uploadFile !== null && !isUploading) {
      setIsLoading(false);
      setIsUploading(true);
      sendFile().finally(() => {
        setIsUploading(false);

        setTimeout(() => {
          // handleCancel();
          setIsOpenUploadModal(false);
        }, 1000);
      });
    }
  }, [uploadFile]);

  return (
    <Modal
      title="Upload"
      open={isModalOpen}
      centered
      closable={false}
      maskClosable={false}
      footer={
        isUploading && (
          <div style={{ marginTop: 20, textAlign: "right" }}>
            <Button onClick={handleCloseModal}>Hủy</Button>
          </div>
        )
      }
    >
      <Typography.Title level={5}>Đang đính kèm tệp</Typography.Title>
      {!isLoading ? (
        <div key={uploadFile?.uid}>
          <div style={{ marginTop: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 10,
              }}
            >
              <Typography.Text>{uploadFile?.name}</Typography.Text>
              {fileUploading.current?.uid === uploadFile?.uid && (
                <CloseOutlined
                  style={{ marginLeft: 10, cursor: "pointer" }}
                  onClick={() => handleDeleteFile(uploadFile?.uid)}
                />
              )}
              <Typography.Text style={{ marginLeft: "auto" }}>
                {getFileSize(uploadFile)}
              </Typography.Text>
            </div>

            <Progress percent={progressState[uploadFile?.uid] || 0} />
          </div>
        </div>
      ) : (
        <div className="w-full h-full items-center justify-center pt-5 pb-5">
          <Spin />
        </div>
      )}
    </Modal>
  );
};

export { PreviewUploadModal };
